export interface NavigationNode {
  name: string
  to?: string
  icon?: string
  exact?: boolean
  children?: NavigationNode[]
  permissions?: string[]
  beta?: boolean
  oldBackofficeLink?: string
  badge?: number
}

const matchPermission = (
  endpointPermission: string,
  userPermission: string,
) => {
  if (userPermission.replace(':w', '').replace(':d', '') === '**') {
    return true
  }
  // BO doesn't care about write rights, but API should throw 403 when needed.
  return (
    userPermission.replace(':w', '').replace(':d', '') === endpointPermission
  )
}

const isAllowed = (
  endpointPermissions: string[],
  userPermissions: string[],
): boolean => {
  if (!endpointPermissions || !endpointPermissions.length) {
    return true
  }

  const matchedPermissions = endpointPermissions.filter((ep) =>
    userPermissions.find((up) => matchPermission(ep, up)),
  )

  return !!matchedPermissions.length
}

const filterByPermissions = (
  nodes: NavigationNode[],
  permissions: string[],
) => {
  return nodes
    .filter((node) => {
      const allowed = isAllowed(node.permissions || [], permissions)

      if (allowed) {
        if (node.children) {
          node.children = filterByPermissions(node.children, permissions)
        }
        return node
      } else {
        console.log(`Restricted ${node.name}`)
      }
    })
    .filter((n) => !!n)
}
// export const isEndpointAllowed = (name: string, permissions: string[]) => {
//   const map = getNavigationItemsMap();
//   console.log('map', name, map)
//   const node = map[name]
//   if (node && node.permissions && node.permissions.length) {
//     return isAllowed(node.permissions, permissions)
//   } else {
//     return true
//   }
// }
// const getNavigationItemsMap = (nodes = NavigationMenu): Record<string, NavigationNode> => {
//   return nodes.reduce((acc, node) => {
//     acc[node.name] = node
//     if (node.children) {
//       return { ...acc, ...getNavigationItemsMap(node.children) }
//     } else {
//       return acc
//     }
//   }, {})
// }
export const getNavigationItems =
  (NavigationMenu: NavigationNode[]) =>
  (permissions: string[] = []) => {
    if (permissions.length) {
      return filterByPermissions(NavigationMenu, permissions)
    } else {
      return NavigationMenu
    }
  }
